<template>
  <div>
    <account-details />
  </div>
</template>

<script>
import AccountDetails from './AccountDetails';

export default {
  components: {
    AccountDetails,
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/accounts/MainView.vue